<template>
    <div class="bulk-message-recipients-import-upload">
        <ContactImportUpload
            :override-import-type="'bulk-message-recipients'"
            :pageCopy="page_copy"
            :fieldDefinitions="field_definitions"
            :previewConfig="preview_config"
            :targetBulkMessageName="target_bulk_message_name"
        />
    </div>
</template>

<script>
import ContactImportUpload from '@/components/contacts/contact-import-component.vue';

export default {
    name: 'BulkMessageRecipientsImportUpload',
    components: { ContactImportUpload },
    data() {
        return {
            target_bulk_message_name: null
        };
    },
    mounted() {
        // For new imports, ensure bulk_message_id is present
        if (!this.$route.query.bulk_message_id && !this.$route.params.import_id) {
            this.$rc.alert('Bulk Message is required for bulk recipients import', 'error');
            this.$router.push(`/app/bulk/messages/${this.$route.params.organization_id}`);
            return;
        }
        // Load target bulk message name when provided via query (new import)
        if (this.$route.query.bulk_message_id) {
            this.loadBulkMessageLabel(this.$route.query.bulk_message_id);
        }
    },
    methods: {
        loadBulkMessageLabel(bulk_message_id) {
            if (!bulk_message_id) {
                return;
            }
            this.$rc.rest({
                spinner: false,
                endpoint: 'GET: /api/v1/bulk/messages/:bulk_message_id',
                params: {
                    bulk_message_id
                },
                on_success: (data) => {
                    // Prefer the main label field
                    this.target_bulk_message_name = data.label || data.name || 'Bulk Message';
                },
                on_error: () => {
                    // Non-blocking; just leave name null
                    this.target_bulk_message_name = null;
                }
            });
        }
    },
    computed: {
        page_copy() {
            return {
                pageTitle: 'Import Bulk Message Recipients',
                instructionsText: 'Upload an Excel file to import contacts and add them as recipients to a bulk message.',
                uploadProgressDescription: 'Uploading and processing your recipients file... please wait.',
                executionProgressTitle: 'Adding Recipients to Bulk Message',
                executionProgressDescription: 'Please wait while we import contacts and add them as recipients. This can take several minutes.',
                executionStatusMessage: 'Importing...',
                completionTitle: 'Bulk Message Recipients Import Complete!',
                completionDescription: 'Your contacts have been imported and added as recipients.',
                historyRouteName: 'search-bulk-message-recipient-imports',
            };
        },
        field_definitions() {
            return {
                requiredFields: [
                    { key: 'phone_number', label: 'Phone Number', description: 'Phone number(s) for the recipient - you can select multiple columns', multiple: true, required: true, hint: 'Select one or more columns containing phone numbers' },
                    { key: 'first_name', label: 'First Name', description: "Recipient's first name", multiple: false, required: true, hint: 'Select the column containing first names' },
                    { key: 'last_name', label: 'Last Name', description: "Recipient's last name", multiple: false, required: true, hint: 'Select the column containing last names' }
                ],
                optionalFields: [
                    { key: 'birthdate', label: 'Birthdate', description: "Recipient's birthdate", multiple: false, required: false, hint: 'Select the column containing birthdates (supports MM/DD/YYYY or YYYY-MM-DD formats)' },
                    { key: 'email', label: 'Email', description: "Recipient's email address", multiple: false, required: false, hint: 'Select the column containing email addresses' },
                    { key: 'notes', label: 'Notes', description: "Recipient's notes", multiple: false, required: false, hint: 'Select the column containing notes' }
                ]
            };
        },
        preview_config() {
            return {
                tableHeaders: [
                    { text: 'Include', value: 'select', align: 'center', sortable: false, alwaysShow: true },
                    { text: 'Row', value: 'row_number', width: '50px', align: 'center', alwaysShow: true },
                    { text: 'Contact Status', value: 'import_status',  align: 'center', alwaysShow: true },
                    { text: 'Bulk Message Recipient Status', value: 'rc_bulk_message_recipient_status',align: 'center', alwaysShow: true },
                    { text: 'Phone Number', value: 'rc_phone_number',  align: 'left', alwaysShow: true },
                    { text: 'First Name', value: 'rc_first_name' },
                    { text: 'Last Name', value: 'rc_last_name' },
                    { text: 'Email', value: 'rc_email' },
                    { text: 'Birthdate', value: 'rc_birthdate' },
                    { text: 'Notes', value: 'rc_notes' },
                    { text: 'Phone Validation Status', value: 'rc_validation_status' },
                    { text: 'System Notes', value: 'rc_system_notes' },
                    { text: 'Errors', value: 'errors', alwaysShow: true }
                ],
                customColumns: [
                    { key: 'select', type: 'custom' },
                    { key: 'rc_bulk_message_recipient_status', type: 'enum' }
                ]
            };
        }
    }
};
</script>

<style scoped>
.bulk-message-recipients-import-upload {
    position: relative;
}
</style>

